function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 753.2c-8.8 0-17.6-3.4-24.4-10.1L74.1 329.6c-13.5-13.4-13.5-35.3 0-48.7 13.4-13.5 35.3-13.5 48.7 0L512 670l389.2-389.1c13.6-13.5 35.2-13.5 48.8 0 13.4 13.4 13.4 35.3 0 48.7L536.3 743.1c-6.7 6.7-15.5 10.1-24.3 10.1z",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgDown;